import { connect } from "react-redux";
import { Dispatch } from "react";
import actions from "redux/actions/Index";
import AgentAssignmentPage from "components/pages/agentAssignment/AgentAssignmentPage";


export const mapStateToProps = (state: any, props: any): any => {
  const { agentAssignment } = state;
  return {
    isLoading: agentAssignment.isLoading,
    isError: agentAssignment.isError,
    error: agentAssignment.error,
    agentChatwootAssignmentCompleted: agentAssignment.agentChatwootAssignmentCompleted,
    agentStoreAssignmentCompleted: agentAssignment.agentStoreAssignmentCompleted
    
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    completeAgentStoreAssignment: (payload: FormData) =>
      dispatch(actions.agentStoreAssignment(payload)),
    completeAgentChatwootAssignment: (payload: FormData) =>
      dispatch(actions.agentChatwootAssignment(payload))
  };
};

const AgentAssignmentContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AgentAssignmentPage);
export default AgentAssignmentContainer;
